module.exports = __webpack_public_path__ + "static/media/bicademia.8f0bb29f.jpg";